import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  caption: {
    color: theme.palette.primary.main,
    alignContent: 'center',
    paddingTop: '2px',
  },
  displayValue: {
    borderBottom: '1px solid rgb(224, 224, 224)',
    alignContent: 'center',
    color: 'rgba(0, 0, 0, 0.6)',
    paddingBottom: '3px',
  },
  displayValueWithoutBottomBorder: {
    alignContent: 'center',
    color: 'rgba(0, 0, 0, 0.6)',
  },
});

const toCamelCase = word => word[0].toUpperCase() + word.slice(1).toLowerCase();


export const BasicInfoItem = (props) => {
  const {
    title,
    text,
    classes,
    lastItem,
  } = props;

  return (
    <div>
      <Typography className={classes.caption} variant="caption">
        {title ? toCamelCase(title) : 'Unknown'}
      </Typography>
      <Typography className={lastItem ? classes.displayValueWithoutBottomBorder : classes.displayValue} variant="headline">
        {text ? toCamelCase(text) : 'Unknown'}
      </Typography>
    </div>
  );
};

BasicInfoItem.defaultProps = {
  lastItem: false,
};

BasicInfoItem.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  classes: PropTypes.shape({}).isRequired,
  lastItem: PropTypes.bool,
};

export default withStyles(styles)(BasicInfoItem);



// WEBPACK FOOTER //
// ./src/components/overview/BasicInformation/BasicInfoItem.jsx